/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const summary = {
  rows: {
    header: [11],
  },
  columns: {
    width: [50, ...Array(28).fill(14)],
    end: 'C',
  },
  table: {
    start: 11,
    end: 30,
    dataStart: 12,
  },
  totalRow: false,
  bordered: true,
};

export const summaryHotel = {
  rows: {
    header: [11],
  },
  columns: {
    width: [25, ...Array(20).fill(12)],
    end: 'U',
  },
  table: {
    start: 11,
    end: 30,
    dataStart: 10,
  },
  totalRow: false,
  bordered: true,
};

export const reteCategory = {
  rows: {
    header: [11],
  },
  columns: {
    width: [25, ...Array(20).fill(18)],
    end: 'U',
  },
  table: {
    start: 11,
    end: 30,
    dataStart: 11,
  },
  totalRow: false,
  bordered: true,
};
